module.exports = __webpack_public_path__ + "img/monitorbox14.568e389c.jpg";